import React from 'react'
import Select from '../../ui/select/Select';
import { ControlProps } from '../form-control-props';
import { withFormControlWrapper } from '../FormControlWrapper';


const SelectControl: React.FC<ControlProps> = (
    {
        name,
        className,
        placeholder,
        setValue,
        multiple = false,
        options,
        value,
        disabled,
    }
) => {
    return (
        <Select
            name={name}
            className={className}
            placeholder={placeholder}
            setValue={setValue}
            multiple={multiple}
            options={options}
            value={value}
            disabled={disabled}
        />
    )
}

export default withFormControlWrapper(
    React.memo(SelectControl, (prevProps, nextProps) => {
        return prevProps.value === nextProps.value
            && prevProps.className === nextProps.className
            && prevProps.placeholder === nextProps.placeholder
            && prevProps.options === nextProps.options
    })
)

